import actions from "../actions";
import { Toast } from "../states/Toast";

const ToastReducer = (state = Toast.initial(), action) => {
  try {
    switch (action.type) {
      case actions.SHOW_TOASTER:
        return Toast.from(action?.payload);

      case actions.HIDE_TOASTER:
        return Toast.close(state);

      default:
        return state;
    }
  } catch (e) {}
};

export default ToastReducer;
